import React from "react";
import moment from "moment";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  List,
  ListItem,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Icon } from "@iconify/react";



function AttackSurfaceReport({ data, pageTitle }) {
  return (
    <Paper elevation={3} sx={{ padding: 3, width: "100%", maxWidth: 900, margin: '0 auto' }}>
      <Box >
      {/* Title & Target */}
      <Typography variant="h4" fontWeight="bold" mb={3} color="rgb(0, 145, 70)" sx={{ textAlign: 'center' }}>
        {pageTitle}
      </Typography>
      

      <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
          <Typography variant="h6" fontWeight="bold">
            <Icon icon="mdi:web" width={24} height={24} style={{ marginRight: 8 }} />
            Target:
          </Typography>
          <Chip label={data.target || data?.result?.domainInfo?.domain} color="primary" variant="outlined" sx={{ fontSize: "1rem", padding: "5px" }} />
        </Box>
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
          <Typography variant="body1" sx={{ color: "#777", mb: 2 }}>
            Report Date: {moment(data?.date).format('MMM DD, YYYY HH:mm')}
          </Typography>
        </Box>

      {/* Domain Information */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
            Domain Information
          </Typography>
          <Typography variant="body1">
            <strong>Domain:</strong> {data?.result?.domainInfo?.domain}
          </Typography>
          <Typography variant="body1">
            <strong>Registrar:</strong> {data?.result?.domainInfo?.registrar}
          </Typography>
          <Typography variant="body1">
            <strong>Expiry Date:</strong> {data?.result?.domainInfo?.expiry}
          </Typography>
        </CardContent>
      </Card>

      {/* Technologies Used */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
            Technology Stack
          </Typography>
          <Grid container spacing={2}>
            {data?.result?.technologiesInfo?.technologiesUsed?.map((tech, index) => (
              <Grid item xs={12} sm={6} key={index}>
                
                <Chip
                  label={`${tech.name} (${tech.description})`}
                  sx={{
                    backgroundColor: tech.vulnerabilitiesFound ? "red" : "green",
                    color: "#fff",
                    fontWeight: "bold",
                    mb: 1,
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>

      {/* MX Records */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
            Mail Exchange (MX) Records
          </Typography>
          <List>
            {data?.result?.MXrecordsInfo?.MXRecord?.mxRecords?.map((record, index) => (
              <ListItem key={index}>📧 {record}</ListItem>
            ))}
          </List>
        </CardContent>
      </Card>

      {/* Host Reputation */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
            Host Reputation
          </Typography>
          <List>
            {data?.result?.hostReputation?.map((host, index) => (
              <ListItem key={index}>
                {host.input} → {host.ip} {host.blacklisted ? "❌ Blacklisted" : "✅ Safe"}
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Card>

      {/* Open Ports */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
            Open Ports
          </Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell><strong>Host</strong></TableCell>
                  <TableCell><strong>Port</strong></TableCell>
                  <TableCell><strong>Service</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.result?.openportsInfo?.map((port, index) => (
                  <TableRow key={index}>
                    <TableCell>{port.hostName}</TableCell>
                    <TableCell>{port.port_id}</TableCell>
                    <TableCell>{port.service_name}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>

      {/* Public URLs */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
            Public URLs
          </Typography>
          <List>
            {data?.result?.publicUrls?.map((url, index) => (
              <ListItem key={index}>
                🔗 <a href={url} target="_blank" rel="noopener noreferrer">{url}</a>
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Card>
    </Box></Paper>
  );
}

export default AttackSurfaceReport;
